import urls from "./urls"

export default route => urls[route.name].props(route)
